import { MutateFn } from '@diritto/common/base/mutateFunction';
import { TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { ProfileFollowApi } from 'api/ApiHelper';
import { useTrackingState } from 'contexts/TrackingProvider';
import { profileFollowQueryKey } from 'queries/profileFollow/queryKey';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useUnFollowProfileMutation = (profileId: number, callback: MutateFn) => {
  const { tracker } = useTrackingState();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: profileFollowQueryKey.profileFollow(profileId),
    mutationFn: () => ProfileFollowApi.unFollowProfile(profileId),
    ...callback,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: profileFollowQueryKey.profileFollow(profileId) });
      tracker.track(TrackingEventType.UnfollowProfile, { profileId });
      callback.onSuccess?.();
    },
  });
};
